import { createAuthClient } from "better-auth/react";
import {
  emailOTPClient,
  magicLinkClient,
  adminClient,
  organizationClient,
  inferAdditionalFields,
  customSessionClient,
} from "better-auth/client/plugins";
import type { auth } from "./auth";

import {
  ac,
  admin_admin,
  admin_user,
  org_enabler,
  org_owner,
  org_admin,
  org_team_manager,
  org_user,
} from "./auth-permissions";
export const authClient = createAuthClient({
  plugins: [
    inferAdditionalFields<typeof auth>(),
    magicLinkClient(),
    emailOTPClient(),
    adminClient({
      ac,
      roles: {
        admin_admin,
        admin_user,
      },
    }),
    organizationClient({
      ac,
      roles: {
        org_owner,
        org_admin,
        org_enabler,
        org_team_manager,
        org_user,
      },
      teams: {
        enabled: true,
      },
    }),
    customSessionClient<typeof auth>(),
  ],
});

export type SessionType = typeof authClient.$Infer.Session;
